module.exports = __webpack_public_path__ + "static/media/Suhail_Rajput_Resume.4e0f28c9.pdf";